import { defineComponent as _defineComponent } from 'vue'
import SensorChartDetails from './SensorChartDetails.vue'
import { SensorSummary } from '@/models/sensors-dto'
import moment from 'moment'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationDetailsSensorsTab',
  props: {
    sensorsList: null
  },
  setup(__props: any) {



const timelineOptions = computed(() => {
  return [
    {
      label: 'Recent',
      range: {
        start: moment().subtract(1, 'week').toDate(),
        end: moment().add(1, 'week').toDate(),
      },
    },
    {
      label: 'Last 2 weeks',
      range: {
        start: moment().subtract(2, 'week').toDate(),
        end: moment().toDate(),
      },
    },
    {
      label: 'Last 30 days',
      range: {
        start: moment().subtract(30, 'day').toDate(),
        end: moment().toDate(),
      },
    },
  ]
})

const timelineSelection = ref<{
  label: string
  range: { start: Date; end: Date }
}>(timelineOptions.value[0])

return { __sfc: true,timelineOptions, timelineSelection, SensorChartDetails }
}

})